import * as THREE from 'three'
import React, { useRef, useEffect } from 'react'
import { useLoader } from 'react-three-fiber';
import { a, useSpring } from 'react-spring/three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import * as easings from 'd3-ease'

export default function Drum({ trigger, flip, isPlaying, setLoaded }) {
  const mesh = useRef()
  const matRef = useRef()
  const gltf = useLoader(GLTFLoader, "/assets/drumHit.glb")

  const r = "/assets/envMap/";
  const urls = [r + "px.png", r + "nx.png",
  r + "py.png", r + "ny.png",
  r + "pz.png", r + "nz.png"];
  const [envMap] = useLoader(THREE.CubeTextureLoader, [urls])
  const [bumpMap] = useLoader(THREE.TextureLoader, ["/assets/bump.jpg"])
  bumpMap.flipY = false

  useEffect(() => {
    if (gltf) setLoaded(true)
  }, [gltf])

  const anim = useSpring({
    to: async (next) => {
      if (!isPlaying) return
      await next({ morph: [1, 0], config: { duration: 100, easing: easings.easeCubicIn } })
      await next({ morph: [-0.5, 1], config: { duration: 200, easing: easings.easeCubic } })
      await next({ morph: [0.25, -0.5], config: { duration: 150, easing: easings.easeCubic } })
      await next({ morph: [-0.125, 0.25], config: { duration: 200, easing: easings.easeCubic } })
      await next({ morph: [0, -0.125], config: { duration: 250, easing: easings.easeCubicOut } })
      await next({ morph: [0, 0], config: { duration: 150, easing: easings.easeCubicOut } })
    },
    from: { morph: [0, 0] }
  }, [trigger, isPlaying])

  const matSettings = {
    drum: {
      roughness: 0.725,
      metalness: 0.2,
      envMap: envMap,
      envMapIntensity: 6,
      map: bumpMap,
      bumpMap: bumpMap,
      bumpScale: 0.05,
      color: new THREE.Color("hsl(0, 0%, 25%)")
    }
  }

  return (
    <group >
      <a.mesh
        ref={mesh}
        name="DrumLeft"
        scale={[flip ? -1 : 1, 1, 1]}
        morphTargetDictionary={gltf.__$[2].morphTargetDictionary}
        morphTargetInfluences={anim.morph.to((m1, m2) => [m1, m2])}>
        <bufferGeometry attach="geometry" {...gltf.__$[2].geometry} />
        <meshPhysicalMaterial ref={matRef} attach="material" {...gltf.__$[2].material} {...matSettings.drum} />
      </a.mesh>
    </group>
  )
}